import type { IAuthLayoutProps } from './AuthLayout'

import { styled } from '@linaria/react'
import { ErrorMessageSC } from 'atoms/ErrorMessage'
import { AuthFormBoxStyled } from 'blocks/AuthFormBox'
import { BrandContainerSC } from 'blocks/BrandContainer'
import { COLOR, FIXED_INDENTS, MEDIA, PAGE_NOTIFICATION } from 'vars/index'

export const AuthLayoutStyled = styled.div<IAuthLayoutProps>`
  width: 100%;
  height: 100%;
  position: relative;
  min-height: 660px;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    background: ${({ posterUrl, background }) =>
      posterUrl
        ? `url(${posterUrl})`
        : background
          ? `var(${background})`
          : 'none'};
    background-size: cover;
    opacity: ${({ backgroundOpacity }) => backgroundOpacity ?? 1};
    transition-property: opacity;
    transition-duration: ${({ backgroundOpacityTransitionDuration }) =>
      `${backgroundOpacityTransitionDuration ?? 1}s`};
    transition-timing-function: ease-out;
    transition-delay: 0s;
  }

  ${BrandContainerSC} {
    position: absolute;
    top: 20px;
    left: 16px;
  }

  ${MEDIA.MIN_600} {
    ${BrandContainerSC} {
      position: absolute;
      top: 24px;
      left: 40px;
    }
  }

  ${MEDIA.MIN_1440} {
    ${BrandContainerSC} {
      top: 40px;
      left: 56px;
    }
  }
`

export const AuthLayoutOverlayStyled = styled.div<
  Omit<IAuthLayoutProps, 'children'>
>`
  display: ${({ overlayEnabled }) => (overlayEnabled ? 'block' : 'none')};
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;

  &:before,
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
  }

  &:before {
    width: ${({ overlayWidth }) => `${overlayWidth || 0}%`};
    height: 100%;
    background: ${({ overlayHorizontalColor }) =>
      `var(${overlayHorizontalColor})`};
  }

  &:after {
    width: 100%;
    height: ${({ overlayHeight }) => `${overlayHeight || 0}%`};
    background: ${({ overlayVerticalColor }) => `var(${overlayVerticalColor})`};
  }
`

export const AuthLayoutContent = styled.div<IAuthLayoutProps>`
  background: var(${COLOR.LOGIN_VERTICAL_OVERLAY});
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'initial'};
  align-items: ${({ alignItems }) => alignItems || 'initial'};

  ${ErrorMessageSC} {
    z-index: 10;
  }

  ${MEDIA.MIN_600} {
    background: var(${COLOR.TRANSPARENT});
  }

  ${MEDIA.MAX_599} {
    align-items: ${({ isMobileVerticalAlignment }) =>
      isMobileVerticalAlignment ? 'center' : 'flex-start'};
    padding-top: ${({ paddingTop = '0px' }) => paddingTop};

    & > ${AuthFormBoxStyled} {
      padding-bottom: var(${FIXED_INDENTS.INDENT_140});
    }
  }
`

export const AuthLayoutWrapperSC = styled.div`
  width: 100%;
  height: 100vh;
  padding-top: var(${PAGE_NOTIFICATION.HEIGHT}, 0px);
`
